import React, { PropTypes } from 'react';
import moment from 'moment';

import { reviewAbridgedPropType } from '../../../proptypes';
import Avatar from '../../Avatar';

import {
  authorDetails,
  createdDate,
  items,
  item,
  avatar,
  reviewText,
  containerColumns,
} from './styles.module.css';

const OrganiserReviews = ({ organiserReviews, reviewType }) => (
  <div>
    <div className={containerColumns}>
      <div className={items}>
        {organiserReviews.map(review => (
          <div key={review.id} className={item}>
            <Avatar
              user={{ ...review.author, pictureUrl: review.author.picture }}
              className={avatar}
            />
            <div>
              <div className={reviewText}>{review[reviewType]}</div>
              <div>
                <span className={authorDetails}>— {review.author.displayName}</span>
                {', '}
                <span className={createdDate}>{moment(review.createdAt).format('Do MMM YY')}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

OrganiserReviews.propTypes = {
  organiserReviews: PropTypes.arrayOf(reviewAbridgedPropType.isRequired).isRequired,
  reviewType: PropTypes.string,
};

OrganiserReviews.defaultProps = {
  reviewType: 'organiserFeedback',
};

export default OrganiserReviews;



// WEBPACK FOOTER //
// ./app/src/components/EventDetail/OrganiserReviews/index.jsx